export default __webpack_public_path__ + "static/media/sinalSuccess.39862bbc.svg";